//#region ../erd-editor-schema/dist/v3/schema/indexColumn.entity.js
var OrderType = {
	ASC: 1,
	DESC: 2
};
var OrderTypeList = Object.values(OrderType);
//#endregion
export { OrderType, OrderTypeList };
